import { Box } from "lucide-react";

const ITEMS = ["Car", "SUV", "Van", "Pickup", "Box Truck", "Truck w/ Trailer", "Drive. Haul. Earn.", "Coming soon"];

export const Marquee = () => (
  <div className="relative bg-[#13296B] text-white py-6 sm:py-8 overflow-hidden" data-testid="vehicle-marquee">
    <div className="marquee-track flex w-max">
      {[0, 1].map((k) => (
        <div key={k} className="flex shrink-0" aria-hidden={k === 1}>
          {ITEMS.map((t) => (
            <span key={t} className="flex items-center gap-8 pr-8 font-display text-3xl sm:text-5xl font-extrabold tracking-tight whitespace-nowrap">
              {t}
              <Box className="h-6 w-6 sm:h-8 sm:w-8 text-[#2F7FF0]" />
            </span>
          ))}
        </div>
      ))}
    </div>
  </div>
);
